import { render, staticRenderFns } from "./Banricompras.vue?vue&type=template&id=b37b928c"
import script from "./Banricompras.vue?vue&type=script&lang=js"
export * from "./Banricompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports